// 保存データを読む（2026-10-29〜）: 付けると外れるカテゴリ（KAWAII の手）をクラシック版と同じ順番で掛け直してから、中身の applySave で読む（core/exclusive.ts の replayExclusive）。
// 作りかけ・テンプレート・画像から読む・外から呼ぶ窓口（window.charatCreate.applySave）はみなこれを通す
import { applySave } from './core/savedata.js';
import { replayExclusive } from './core/exclusive.js';
import type { SaveData } from './types.js';

export function loadSave(save: SaveData) { applySave(replayExclusive(save)); }
